/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AutoReconnectConnection } from './connection';

/**
 * AFFiNE `packages/common/nbstore/src/connection/shared-connection.ts` 그대로.
 * shareId 로 전역 dedupe → 같은 리소스엔 연결 1개만.
 */
const CONNECTIONS: Map<string, AutoReconnectConnection<any>> = new Map();
export function share<T extends AutoReconnectConnection<any>>(conn: T): T {
  const shareId = conn.shareId;
  if (!shareId) {
    throw new Error(
      `Connection ${conn.constructor.name} is not shareable.\nIf you want to make it shareable, please override [shareId].`,
    );
  }

  const existing = CONNECTIONS.get(shareId);

  if (existing) {
    return existing as T;
  }

  CONNECTIONS.set(shareId, conn);

  // ⚠️ AFFiNE 원본과의 의도적 차이 (원본엔 이 블록이 없음).
  // AFFiNE 공유 연결은 endpoint당 1개·앱 수명 내내 영속이라 map에 남겨도 무해하다.
  // 우리 SSE는 job(resource)당 단명이다 → 'closed'된 연결이 map에 남으면 다음 share()가
  // 그 좀비를 재사용하고, connect() 시 AutoReconnect가 죽은 연결을 되살려 재연결 폭풍을 만든다.
  // 'closed' 진입 시 제거해 다음 share()가 새 연결을 만들게 한다.
  const off = conn.onStatusChanged((status) => {
    if (status !== 'closed') return;
    if (CONNECTIONS.get(shareId) === conn) CONNECTIONS.delete(shareId);
    off();
  });

  return conn;
}
